import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { RecoverPassStep } from "./recover-password.vm";

@Component({
    selector: "ui-sec-recover-password",
    templateUrl: "./recover-password-card.component.html",
    styleUrls: ["./recover-password-card.component.scss"],
    standalone: false,
})
export class RecoverPasswordCardComponent implements OnInit, OnChanges {

    @Input() form!: FormGroup;
    @Input() step: RecoverPassStep = 'email';

    @Input() title = '';
    @Input() subtitle = '';
    @Input() description = '';

    @Input() primaryButtonLabel = 'Continuar';
    @Input() primaryButtonDisabled = false;

    @Input() showTerms = true;

    @Input() showPasswordMismatch: boolean = false;

    @Output() submitted = new EventEmitter<void>();
    @Output() resendCode = new EventEmitter<void>();
    @Output() goBack = new EventEmitter<void>();

    secondsToResend: number = 120;
    formattedTime = '02:00';
    canResend = false;
    private intervalId: any;

    passwordHint = 'Debe tener al menos 8 caracteres';

    ngOnInit(): void {
        if (this.step === 'code') {
            this.initCountdown();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['step']) return;

        const previous = changes['step'].previousValue;
        const current = changes['step'].currentValue;

        // El countdown solo arranca al ENTRAR a 'code' por primera vez.
        // Si volvemos de 'validating' (estado de loading interno tras
        // submitear el codigo y fallar la validacion) NO debemos reiniciar
        // el contador, porque sino el usuario que se equivoca el codigo
        // antes de los 2 min jamas vera aparecer el boton de reenviar
        // (incidencia #28).
        if (current === 'code' && previous !== 'validating') {
            this.initCountdown();
        } else if (current !== 'code' && current !== 'validating') {
            this.stopCountdown();
        }
    }

    private initCountdown() {
        this.stopCountdown();
        this.secondsToResend = 120;
        this.canResend = false;
        this.updateFormattedTime();

        this.intervalId = setInterval(() => {
            this.secondsToResend--;
            this.updateFormattedTime();

            if (this.secondsToResend <= 0) {
                this.canResend = true;
                this.stopCountdown();
            }
        }, 1000);
    }

    private stopCountdown() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    private updateFormattedTime() {
        const m = Math.floor(this.secondsToResend / 60)
            .toString()
            .padStart(2, '0');

        const s = (this.secondsToResend % 60)
            .toString()
            .padStart(2, '0');

        this.formattedTime = `${m}:${s}`;
    }

    onPrimaryClick(): void {
        this.submitted.emit();
    }

    onResendClick(): void {
        if (!this.canResend) return;

        this.resendCode.emit();
        this.initCountdown();
    }

    onGoBack(): void {
        this.goBack.emit();
    }

    getPasswordError(controlName: 'newPassword' | 'confirmPassword'): string | null {
        const control = this.form.get(controlName);
        if (!control) return null;

        const touched = control.dirty || control.touched;

        if (touched && control.errors?.['minlength']) {
            return 'Debe tener al menos 8 caracteres';
        }

        if (controlName === 'confirmPassword' && this.showPasswordMismatch) {
            return 'Contraseña no coincide';
        }

        return null;
    }
}